<template>
  <div class="bids-add-bulk-column-slider">
    <BidsAddBulkColumnChooserColumns
      :selected-column="selectedColumn"
      :current-slide="currentSlide"
      :per-row="4"
      :data="data"
      @selectedColumnChange="selectedColumnChange"
    />

    <BidsAddBulkColumnSliderNavigation
      v-model="currentSlide"
      class="bids-add-bulk-column-slider__navigation"
      :columns-count="data.length"
      :per-row="4"
    />
  </div>
</template>

<script>
import BidsAddBulkColumnChooserColumns from './BidsAddBulkColumnChooserColumns';
import BidsAddBulkColumnSliderNavigation from './BidsAddBulkColumnSliderNavigation';

export default {
  name: 'BidsAddBulkColumnSlider',
  components: {
    BidsAddBulkColumnChooserColumns,
    BidsAddBulkColumnSliderNavigation,
  },
  model: {
    prop: 'selectedColumn',
    event: 'selectedColumnChange',
  },
  props: {
    data: {
      required: true,
      type: Array,
    },
    selectedColumn: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      currentSlide: 0,
    };
  },
  methods: {
    selectedColumnChange(selectedColumn) {
      this.$emit('selectedColumnChange', selectedColumn);
    },
  },
};
</script>

<style lang="scss">
.bids-add-bulk-column-slider {
  &__navigation {
    margin-top: $global-margin;
  }
}
</style>
